import React from 'react'
import { GetReportResponse } from '@/hooks'
import { ExportUsageCostReport } from './ExportUsageCostReport'
import { ExportPayablesReport } from './ExportPayablesReport'
import { ExportBenchmarkingReport } from './ExportBenchmarkingReport'
import { ExportTotalEmissionsReport } from './ExportTotalEmissionsReport'
import { ExportGHGEmissionsReport } from './ExportGHGEmissionsReport'
import { ExportIntervalDataReport } from './ExportIntervalDataReport'

export type ExportReportMenuItemProps = {
    reportData: GetReportResponse
    onClick?: () => void
    onExportingChange?: (isExporting: boolean) => void
}

const reportComponents: Record<
    GetReportResponse['type'],
    React.FC<{
        reportId: string
        onClick?: () => void
        onExportingChange?: (isExporting: boolean) => void
    }>
> = {
    'usage-cost': ExportUsageCostReport,
    'payables-summary': ExportPayablesReport,
    benchmarking: ExportBenchmarkingReport,
    'total-emissions': ExportTotalEmissionsReport,
    'ghg-emissions': ExportGHGEmissionsReport,
    'interval-data': ExportIntervalDataReport,
}

export const ExportReportMenuItem: React.FC<ExportReportMenuItemProps> = ({
    reportData,
    onClick,
    onExportingChange,
}) => {
    const Component = reportComponents[reportData.type]

    return (
        <Component
            reportId={reportData.customReportId}
            onClick={onClick}
            onExportingChange={onExportingChange}
        />
    )
}
